import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home/Home.vue'
import MusicListItem from '@/views/MusicListItem/MusicListItem.vue'
import Search from '@/views/Search/Search.vue'
import Login from '@/views/Login/Login.vue'
import store from '@/store'
import MyCenter from '@/views/MyCenter/MyCenter.vue'
import Mv from '@/components/MusicListItem/Mv.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/musiclistitem',
    name: 'musiclistitem',
    component: MusicListItem,
  },
  {
    path: '/mv',
    name: 'mv',
    component: Mv,
  },
  {
    path: '/search',
    name: 'search',
    component: Search
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/center',
    name: 'center',
    beforeEnter: (to, from, next) => {
      if(store.state.isLogin||store.state.token||localStorage.getItem('token')){
          next()
      }else{
        next('/login')
      }
    },
    component: MyCenter
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to)=>{
  if(to.path=='/login'||to.path=='/center'||to.path=='/mv'){
    store.state.isFooterMusic=false
  }else {
    store.state.isFooterMusic=true
  }
})

export default router
